import { Input } from "antd";
import React, { useState, useRef, useEffect } from "react";
import { FaRegEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

function OTP({ otp, setOtp, handleOtpSend, resendAfter = 60 }) {
  const [isOtpVisible, setIsOtpVisible] = useState(false);
  const [timer, setTimer] = useState(resendAfter);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const inputRefs = useRef([]);

  useEffect(() => {
    setTimer(Number(resendAfter) || 60);
    setIsResendDisabled(true);
  }, [resendAfter]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setIsResendDisabled(false);
    }
  }, [timer]);

  const handleChange = (element, index) => {
    const value = element.value;
    if (/[^0-9]/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleBackspace = (event, index) => {
    if (event.key === "Backspace" && !event.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const toggleVisibility = () => {
    setIsOtpVisible(!isOtpVisible);
  };

  const resendOtp = async () => {
    setOtp(Array(6).fill(""));
    const resendSeconds = await handleOtpSend();
    if (resendSeconds) {
      setTimer(Number(resendSeconds) || 60);
      setIsResendDisabled(true);
      inputRefs.current[0]?.focus();
    }
  };

  const formattedTimer = `${String(Math.floor(timer / 60)).padStart(2, "0")}:${String(timer % 60).padStart(2, "0")}`;

  return (
    <>
      <div className="otp-container d-flex align-items-center justify-content-center ">
        {otp.map((data, index) => (
          <Input
            autoFocus={index === 0}
            key={index}
            type={isOtpVisible ? "text" : "password"}
            inputMode="numeric"
            pattern="[0-9]*"
            autoComplete={index === 0 ? "one-time-code" : "off"}
            maxLength="1"
            className="otp-input formInput"
            value={data}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => handleBackspace(e, index)}
            ref={(el) => (inputRefs.current[index] = el)}
          />
        ))}
        <span className="toggle-visibility" onClick={toggleVisibility}>
          {isOtpVisible ? <FaEyeSlash /> : <FaRegEye />}
        </span>
      </div>
      <div className="resend-container d-flex align-items-center justify-content-start my-3">
        Didn't recived otp?&nbsp;
        {isResendDisabled ? (
          <span className="timer">Resend in {formattedTimer}</span>
        ) : (
          <button
            className="resend-button"
            type="button"
            onClick={resendOtp}
          >
            Resend OTP
          </button>
        )}
      </div>
      <p className="otp-help-text">OTP not received? Check your Spam folder.</p>
    </>
  );
}

export default OTP;
